import React from "react";
import "./MarkerCircle.css";
import {ChargingStationPOI, PointOfInterest} from "../logic/APITypes";
import {AdvancedMarker} from "@vis.gl/react-google-maps";
import type {Marker} from "@googlemaps/markerclusterer";

function MarkerCircle(props: {
  chargingPoi: ChargingStationPOI;
  openPoi: (poi: PointOfInterest) => void;
  setMarkerRef: (
    type: "construction" | "charging",
    marker: Marker | null,
    key: string,
  ) => void;
}) {
  const circuitColor = (circuit: ChargingStationPOI["circuits"][number]) => {
    return {
      Frei: "#328734",
      Belegt: "#2581c4",
      "Nicht verfügbar": "#D50042",
      "Status lädt…": "#A8A8A8",
    }[circuit.status];
  };

  return (
    <AdvancedMarker
      position={{lat: props.chargingPoi.lat, lng: props.chargingPoi.lng}}
      ref={(marker) =>
        props.setMarkerRef("charging", marker, props.chargingPoi.id)
      }
      onClick={() => props.openPoi(props.chargingPoi)}
      title={props.chargingPoi.name}
      anchorPoint={["50%", "50%"]}
    >
      <div className="markerCircle">
        {props.chargingPoi.behindBarrier ? (
          <></>
        ) : props.chargingPoi.circuits.length > 10 ? (
          <div className="markerCircle__text">
            {
              props.chargingPoi.circuits.filter((c) => c.status === "Frei")
                .length
            }
          </div>
        ) : (
          props.chargingPoi.circuits.some(
            (circuit) => circuit.powerType === "DC",
          ) && <div className="markerCircle__text">DC</div>
        )}
        <svg
          width="36"
          height="36"
          viewBox="-41 -41 82 82"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {props.chargingPoi.behindBarrier ? (
            <>
              <circle cx="0" cy="0" r="23" fill="rgba(37, 130, 196, 0.75)" />
              <path d="M-12 -8L0 -14 L12 -8" strokeWidth="5" stroke="white" />
              <text
                x="0"
                y="16"
                textAnchor="middle"
                fontWeight="700"
                fontSize="28"
                fill="white"
              >
                P
              </text>
            </>
          ) : props.chargingPoi.circuits.some(
              (circuit) => circuit.powerType === "DC",
            ) ? (
            <circle cx="0" cy="0" r="23" fill="rgba(255, 255, 255, 0.75)" />
          ) : null}
          {props.chargingPoi.circuits.length < 2 ? (
            <circle
              cx="0"
              cy="0"
              r="32"
              stroke={
                props.chargingPoi.circuits.length === 1
                  ? circuitColor(props.chargingPoi.circuits[0])
                  : "#A8A8A8"
              }
              strokeWidth="18"
            />
          ) : props.chargingPoi.circuits.length === 2 ? (
            props.chargingPoi.circuits.map((circuit, i) => (
              <path
                key={props.chargingPoi.id + "circuitIcon" + i}
                d="M -2 -32 A 30 32 0 0 0 -2 32"
                stroke={circuitColor(circuit)}
                strokeWidth="18"
                transform={`rotate(${(i + 1) * 180})`}
              />
            ))
          ) : props.chargingPoi.circuits.length === 4 ? (
            props.chargingPoi.circuits.map((circuit, i) => (
              <path
                key={props.chargingPoi.id + "circuitIcon" + i}
                d="M 32 -2 A 30 30 0 0 0 2 -32"
                stroke={circuitColor(circuit)}
                strokeWidth="18"
                transform={`rotate(${i * 90})`}
              />
            ))
          ) : (
            props.chargingPoi.circuits.map((circuit, i) => (
              <path
                key={props.chargingPoi.id + "circuitIcon" + i}
                d={
                  props.chargingPoi.circuits.length <= 10
                    ? `M ${30 * Math.cos(2 * Math.PI * (i / props.chargingPoi.circuits.length + 0.01))} ${30 * Math.sin(2 * Math.PI * (i / props.chargingPoi.circuits.length + 0.01))} A 30 30 0 0 1 ${30 * Math.cos(2 * Math.PI * ((i + 1) / props.chargingPoi.circuits.length - 0.01))} ${30 * Math.sin(2 * Math.PI * ((i + 1) / props.chargingPoi.circuits.length - 0.01))}`
                    : `M ${30 * Math.cos(2 * Math.PI * (i / props.chargingPoi.circuits.length))} ${30 * Math.sin(2 * Math.PI * (i / props.chargingPoi.circuits.length))} A 30 30 0 0 1 ${30 * Math.cos(2 * Math.PI * ((i + 1) / props.chargingPoi.circuits.length))} ${30 * Math.sin(2 * Math.PI * ((i + 1) / props.chargingPoi.circuits.length))}`
                }
                fill="none"
                stroke={circuitColor(circuit)}
                strokeWidth="18"
                transform="rotate(-90)"
              />
            ))
          )}
        </svg>
      </div>
    </AdvancedMarker>
  );
}

export default MarkerCircle;
